import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { IBlockNumberSchema, ICreateBlockNumberSchema } from "../../Schemas/BlockNumber";



export interface block_numbersListResponseBody extends IResponseBody {
  data: {
    block_numbers: IBlockNumberSchema;
  };
}


export class BlockNumbersCreateRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/block-numbers/create`;
  }

  async send(
    blockNumberCreateBody: ICreateBlockNumberSchema
  ): Promise<block_numbersListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(),
        blockNumberCreateBody
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
